var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "text-center" }, [
        _c("h4", [_vm._v("Your Progress")]),
        _vm._v(" "),
        _c("div", { staticClass: "progress" }, [
          _c(
            "div",
            {
              staticClass: "progress-bar",
              class: _vm.color,
              style: _vm.style,
              attrs: {
                role: "progressbar",
                "aria-valuemin": "0",
                "aria-valuemax": "100",
                "aria-valuenow": _vm.percent,
              },
            },
            [
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.percent) + "%"),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                " +
              _vm._s(_vm.tasksDone) +
              " out of " +
              _vm._s(_vm.tasksCount) +
              " Tasks Complete!\n            "
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }